module.exports = __webpack_public_path__ + "static/ios-bfc56be9ffa3a47ac970255d1eb09c41.svg";